import {
  couponRecords,
  couponCategorys,
  couponCategoryOptions,
  createCoupon,
  distributionCoupon,
  couponDetailRecords,
  writeOffCoupon,
  delCouponState,
  couponMakePaper,
  queryChildOrgCouponStatistics,
  queryChildOrgCardStatistics,
  writeOffCouponAndCardStatistics,
  queryCouponDetailOfDiscountForm,
  queryCouponByNo,
  queryWriteOffRecordByPage,
  queryWriteOffDetail,
  addCouponCategory,
  doGrant,
  doGrantCheck,
  couponApprovateListByPage,
  doBackOff,
  queryOrgCouponCodeByPage,
  queryCanComposeCouponRecordList,
  createCouponCode,
  queryCouponCategories,
  queryCouponCodeDetailById,
  synchCouponCodeToH5Get,
  pullOffCouponCode,
  voidCouponCode,
  queryReceiveRecordOfCouponCodeByPage,
  queryEmpowerOrgStatisticsByPage,
  queryEmpowerOrgStatisticsDetailByPage,
  queryCouponCodeSynchRecordListByPage,
  approvateSynchApply,
  queryCouponTypeByPage,
  createCouponType,
  queryCouponTypeList,
  drawBackCouponCode,
  queryCouponCodeOption,
  syncToShop,
  queryOrgCouponCodeForSelect
} from '@/api/sys.coupon'

export default {
  namespaced: true,
  actions: {
    /**
         * 分页查询
         */
    couponRecords ({
      dispatch
    }, {
      vm,
      data
    }) {
      return couponRecords(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },

    /**
         * @description 新增机构
         * @param {Object} param context
         * @param {Object} param vm {Object} vue 实例
         * @param {Object} param data {Object} 数据
         */
    createCoupon ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求
      return createCoupon(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    distributionCoupon ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求
      return distributionCoupon(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
         * 分页查询
         */
    couponDetailRecords ({
      dispatch
    }, {
      vm,
      data
    }) {
      return couponDetailRecords(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
         *核销
         */
    writeOffCoupon ({
      dispatch
    }, {
      vm,
      data
    }) {
      return writeOffCoupon(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    delCouponState ({
      dispatch
    }, {
      vm,
      data
    }) {
      return delCouponState(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    couponMakePaper ({
      dispatch
    }, {
      vm,
      data
    }) {
      return couponMakePaper(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    queryChildOrgCouponStatistics ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryChildOrgCouponStatistics(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    queryChildOrgCardStatistics ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryChildOrgCardStatistics(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    writeOffCouponAndCardStatistics ({
      dispatch
    }, {
      vm,
      data
    }) {
      return writeOffCouponAndCardStatistics(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    queryCouponDetailOfDiscountForm ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryCouponDetailOfDiscountForm(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },

    queryCouponByNo ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryCouponByNo(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    queryWriteOffRecordByPage ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryWriteOffRecordByPage(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    queryWriteOffDetail ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryWriteOffDetail(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
         * @description 新增券类型
         * @param {Object} param context
         * @param {Object} param vm {Object} vue 实例
         * @param {Object} param data {Object} 数据
         */
    addCouponCategory ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求
      return addCouponCategory(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
         * 分页查询
         */
    couponCategorys ({
      dispatch
    }, {
      vm,
      data
    }) {
      return couponCategorys(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
         * 券选项列表
         */
    loadCategoryOptions ({
      dispatch
    }, {
      vm,
      data
    }) {
      return couponCategoryOptions(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
         * @description 优惠券授权
         * @param {Object} param context
         * @param {Object} param vm {Object} vue 实例
         * @param {Object} param data {Object} 数据
         */
    doGrant ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求
      return doGrant(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
         * @description 优惠券授权审核
         * @param {Object} param context
         * @param {Object} param vm {Object} vue 实例
         * @param {Object} param data {Object} 数据
         */
    doGrantCheck ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求
      return doGrantCheck(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
         * 分页查询
         */
    couponApprovateListByPage ({
      dispatch
    }, {
      vm,
      data
    }) {
      return couponApprovateListByPage(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
         * @description 原路退回
         * @param {Object} param context
         * @param {Object} param vm {Object} vue 实例
         * @param {Object} param data {Object} 数据
         */
    doBackOff ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求
      return doBackOff(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
         * 分页查询
         */
    queryOrgCouponCodeByPage ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryOrgCouponCodeByPage(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
         * 查询可选择的券包
         */
    queryCanComposeCouponRecordList ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryCanComposeCouponRecordList(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
         * 查询可选择的券包
         */
    queryCouponCategories ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryCouponCategories(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
         * 套餐详情
         */
    queryCouponCodeDetailById ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryCouponCodeDetailById(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
         * @description 新增券类型
         * @param {Object} param context
         * @param {Object} param vm {Object} vue 实例
         * @param {Object} param data {Object} 数据
         */
    createCouponCode ({
      dispatch
    }, {
      data
    }) {
      // 开始请求
      return createCouponCode(data)
        .then(res => {
          return res
        })
        .catch(err => {
          console.log('err: ', err)
        })
    },
    /**
         * @description 同步至领券页
         * @param {Object} param context
         * @param {Object} param vm {Object} vue 实例
         * @param {Object} param data {Object} 数据
         */
    synchCouponCodeToH5Get ({
      dispatch
    }, {
      data
    }) {
      // 开始请求
      return synchCouponCodeToH5Get(data)
        .then(res => {
          return res
        })
        .catch(err => {
          console.log('err: ', err)
        })
    },
    /**
         * @description 取消同步
         * @param {Object} param context
         * @param {Object} param vm {Object} vue 实例
         * @param {Object} param data {Object} 数据
         */
    pullOffCouponCode ({
      dispatch
    }, {
      data
    }) {
      // 开始请求
      return pullOffCouponCode(data)
        .then(res => {
          return res
        })
        .catch(err => {
          console.log('err: ', err)
        })
    },
    syncToShop ({
      dispatch
    }, {
      data
    }) {
      // 开始请求
      return syncToShop(data)
        .then(res => {
          return res
        })
        .catch(err => {
          console.log('err: ', err)
        })
    },
    /**
         * @description 套餐作废
         * @param {Object} param context
         * @param {Object} param vm {Object} vue 实例
         * @param {Object} param data {Object} 数据
         */
    voidCouponCode ({
      dispatch
    }, {
      data
    }) {
      // 开始请求
      return voidCouponCode(data)
        .then(res => {
          return res
        })
        .catch(err => {
          console.log('err: ', err)
        })
    },
    queryReceiveRecordOfCouponCodeByPage ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryReceiveRecordOfCouponCodeByPage(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    queryEmpowerOrgStatisticsByPage ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryEmpowerOrgStatisticsByPage(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    queryEmpowerOrgStatisticsDetailByPage ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryEmpowerOrgStatisticsDetailByPage(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },

    queryCouponCodeSynchRecordListByPage ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryCouponCodeSynchRecordListByPage(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    approvateSynchApply ({
      dispatch
    }, {
      vm,
      data
    }) {
      return approvateSynchApply(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    queryCouponTypeByPage ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryCouponTypeByPage(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    createCouponType ({
      dispatch
    }, {
      vm,
      data
    }) {
      return createCouponType(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    queryCouponTypeList ({
      dispatch
    }) {
      return queryCouponTypeList()
        .then(res => {
          return res
        })
    },
    drawBackCouponCode ({
      dispatch
    }, {
      vm,
      data
    }) {
      return drawBackCouponCode(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    queryCouponCodeOption ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryCouponCodeOption(data)
        .then(res => {
          return res
        })
        .catch(err => {
          console.log('err: ', err)
        })
    },
    queryOrgCouponCodeForSelect ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryOrgCouponCodeForSelect(data)
        .then(res => {
          return res
        })
        .catch(err => {
          console.log('err: ', err)
        })
    }
    
  }
}
